import { getSvgSelected, getSvgNonSelected, getSvgSomeSelected } from "../../../../utils/domElements";
export default function HeaderCellCheckbox(params) {
  var _context$checkboxData, _context$checkboxData2, _context$checkboxData3, _params$checkbox;
  const {
    checkbox,
    column,
    context
  } = params;
  if (!checkbox) return null;
  let colId = column.colId;
  let checkedRowsList = [];
  if (context !== null && context !== void 0 && (_context$checkboxData = context.checkboxData) !== null && _context$checkboxData !== void 0 && (_context$checkboxData2 = _context$checkboxData[colId]) !== null && _context$checkboxData2 !== void 0 && _context$checkboxData2.rows) {
    checkedRowsList = Object.keys(context.checkboxData[colId].rows).filter(current => context.checkboxData[colId].rows[current]) || [];
  }
  const isDisabled = checkbox.isDisabled && checkbox.isDisabled(colId) || false;
  let isChecked = checkedRowsList.length > 0 || false;
  let areAllChecked = false;
  if ((_context$checkboxData3 = context.checkboxData) !== null && _context$checkboxData3 !== void 0 && _context$checkboxData3[colId]) {
    var _context$checkboxData4, _context$checkboxData5;
    areAllChecked = ((_context$checkboxData4 = context.checkboxData) === null || _context$checkboxData4 === void 0 ? void 0 : (_context$checkboxData5 = _context$checkboxData4[colId]) === null || _context$checkboxData5 === void 0 ? void 0 : _context$checkboxData5.areAllChecked) || false;
  }
  const tableId = (context === null || context === void 0 ? void 0 : context.tableId) || '';
  const svg = getSvg(isChecked, areAllChecked, tableId, colId);
  const cell = document.createElement('div');
  cell.classList.add('w5-header-cell-checkbox');
  if (isDisabled) cell.classList.add('w5-header-cell-checkbox--disabled');
  if (!params.useDragColumns && params.useDragRows && params !== null && params !== void 0 && (_params$checkbox = params.checkbox) !== null && _params$checkbox !== void 0 && _params$checkbox.onClick) {
    cell.classList.add('w5-header-cell-checkbox__align-with-rows');
  }
  if (!svg) return cell;
  if (checkbox.onClick) {
    svg.addEventListener('click', handleOnChange(cell, svg, colId, isChecked, areAllChecked, isDisabled, checkbox.onClick, context, column, tableId));
  }
  cell.appendChild(svg);
  return cell;
}
const getSvg = (isChecked, areAllChecked, tableId, colId) => {
  const svgContainer = document.createElement('div');
  svgContainer.classList.add('w5-header-cell-checkbox__svg-container');
  if (areAllChecked) {
    const svgSelected = getSvgSelected(tableId, colId);
    if (!svgSelected) return null;
    svgContainer.innerHTML = svgSelected;
  } else if (isChecked) {
    const svgSomeSelected = getSvgSomeSelected(tableId, colId);
    if (!svgSomeSelected) return null;
    svgContainer.innerHTML = svgSomeSelected;
  } else {
    const svgNonSelected = getSvgNonSelected(tableId, colId);
    if (!svgNonSelected) return null;
    svgContainer.innerHTML = svgNonSelected;
  }
  return svgContainer;
};
const handleOnChange = (cell, svg, colId, isChecked, areAllChecked, isDisabled, onClick, context, column, tableId) => event => {
  event.preventDefault();
  event.stopPropagation();
  if (isDisabled) return;
  if (!isChecked && !areAllChecked) {
    isChecked = true;
    areAllChecked = true;
  } else if (isChecked && !areAllChecked) {
    isChecked = false;
  } else if (isChecked && areAllChecked) {
    isChecked = false;
    areAllChecked = false;
  }
  svg.remove();
  const newSvg = getSvg(isChecked, areAllChecked, tableId, colId);
  if (!newSvg) return null;
  newSvg.addEventListener('click', handleOnChange(cell, newSvg, colId, isChecked, areAllChecked, isDisabled, onClick, context, column, tableId));
  cell.appendChild(newSvg);
  onClick({
    colId,
    boolean: areAllChecked,
    context,
    column
  });
};